<template>
    <el-dialog title="请选择替换站点" :visible.sync="replaceShow" width="30%" :before-close="handleClose">
        <div class="replace-radio" v-loading="loading">
            <ul>
                <li v-show="replaceData.pcCount>0 && replaceData.projType ==='PC' ">
                    <el-radio v-model="radio" :label="replaceData.projType"></el-radio>
                    <span class="replace-btn">开通{{replaceData.projType}}站</span>
                </li>
                <li v-show="replaceData.mcCount>0 && replaceData.projType ==='手机'">
                    <el-radio v-model="radio" :label="replaceData.projType"></el-radio>
                    <span class="replace-btn">开通{{replaceData.projType}}站</span>
                </li>
                <li v-show="replaceData.pcCount>0 && replaceData.mcCount>0 &&replaceData.projType ==='响应式'">
                    <el-radio v-model="radio" :label="replaceData.projType"></el-radio>
                    <span class="replace-btn">开通{{replaceData.projType}}站</span>
                </li>
                <li v-for="(item,index) in projListData" :key="item.id+index">
                    <el-radio v-model="radio" :label="item.id"></el-radio>
                    <span>
                        <a :href="getProjUrl(item)" target="_blank">{{getProjUrl(item)}}</a>
                    </span>
                    <!-- <i class="iconfont icon-yulan1" @click="goLink(getProjUrl(item))" title="预览"></i> -->
                </li>
            </ul>
            <div class="replace-hint" v-show="isTpl && replaceData.projType ==='响应式' && (replaceData.pcCount===0 || replaceData.mcCount===0)">您未购买响应式网站或不包含1套未开通的PC+手机站，无法体验变正式上线</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <span v-show="!loading">
                <el-button type="primary" class="large-warning" @click="replaceWeb">确 定</el-button>
                <el-button class="large-warning" @click="handleClose" v-show="!isTpl && (replaceData.pcCount===0 || replaceData.mcCount===0)">取 消</el-button>
            </span>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import ConsoleApi from '@/api/console.api'
export default {
    props: {
        replaceShow: {
            type: Boolean,
            defalut: false
        },
        replaceData: {
            type: Object
        },
    },
    data () {
        return {
            loading: true,
            radio: '',
            projListData: [],
            isTpl: false
        }
    },
    computed: {
        ...mapGetters('user', ['userInfo']),
        ...mapState(['globals']),
    },
    created () {
        this.getList()
    },
    methods: {
        handleClose () {
            this.$emit('updateReplaceWeb')
        },
        getProjUrl (curProj) {
            return curProj.projectDomain ? 'http://' + curProj.projectDomain : this.globals.baseUrl + '/page/projhtml?&projId=' + curProj.id
        },
        async getList () {
            this.loading = true
            let params = {
                userId: this.userInfo.uid,
                status: 0,
                pageSize: 40,
                pageNum: 1,
                projType: this.replaceData.projType
            }
            const { data } = await ConsoleApi.getSitesList(params)
            this.loading = false
            if (data.isSuccess) {
                this.projListData = data.data.list.filter(item => {
                    return item.experience === '0' && item.projType === this.replaceData.projType && this.isReplace(item.lineStartTime)
                })
                this.isTpl = this.projListData.length === 0
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                })
            }
        },
        isReplace (tiem) {
            if (!tiem) return true
            const Format = moment(tiem).format()
            const currentTiem = moment().format()
            const tiemInfo = moment(currentTiem).diff(Format, 'days')
            return tiemInfo <= 90
        },
        async replaceWeb () {
            if (this.isTpl) {
                this.handleClose()
                return
            }
            if (this.radio === '') {
                this.$message({
                    message: '请选择要替换的站点',
                    type: 'error'
                })
                return
            }
            let params = {
                experienceProjectId: this.replaceData.projectId
            }
            if (this.radio != this.replaceData.projType) {
                params.formalProjectId = this.radio
            }
            const { data } = await ConsoleApi.updateExperience(params)
            if (data.isSuccess) {
                this.$message({
                    message: '替换成功',
                    type: 'success'
                })
                this.$emit('getList')
                this.$emit('updateReplaceWeb')
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                })
            }
        },
        goLink (link) {
            window.open(link)
        }
    }
}
</script>

<style scoped lang="scss">
.replace-radio {
    width: 100%;
    text-align: left;
    min-height: 52px;
    li {
        margin-bottom: 5px;
        .el-radio {
            max-width: 80%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        & > span {
            margin-left: 10px;
            max-width: 80%;
            vertical-align: text-bottom;
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        a:hover {
            color: $colorA;
        }
        .iconfont {
            margin-left: 10px;
            vertical-align: text-bottom;
            cursor: pointer;
            a {
                display: block;
            }
        }
    }
    .el-radio__input {
        vertical-align: top;
    }
    .replace-btn {
        width: 90px;
        height: 30px;
        background: #f1592a;
        border-radius: 2px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }
}
.replace-hint {
    color: #515567;
    font-size: 16px;
    letter-spacing: 2px;
    .icon3 {
        display: block;
        margin: 0 auto 20px;
    }
}
.dialog-footer {
    display: block;
    height: 37px;
}
</style>
